var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.514 16C2.514 8.552 8.552 2.514 16 2.514S29.486 8.552 29.486 16 23.448 29.486 16 29.486 2.514 23.448 2.514 16zM16 1C7.716 1 1 7.716 1 16s6.716 15 15 15 15-6.716 15-15S24.284 1 16 1zm2.952 5.3v3.782h4.202a.757.757 0 0 1 0 1.514H9.604v8.809h4.175a.647.647 0 0 1 .024 0h8.593v-3.78h-8.593a.757.757 0 0 1 0-1.513h9.35c.418 0 .757.34.757.757v5.292a.757.757 0 0 1-.756.756h-4.201v3.686a.757.757 0 1 1-1.514 0v-3.686h-2.88v3.686a.757.757 0 1 1-1.513 0v-3.686h-4.2a.757.757 0 0 1-.757-.756V10.839c0-.419.338-.758.756-.758h4.2V6.3a.757.757 0 1 1 1.514 0v3.686h2.88V6.3a.757.757 0 1 1 1.512 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmt);
export default __webpack_public_path__ + "static/media/GMT.12be79c44476a69963c7ef40470e99da.svg";
export { ForwardRef as ReactComponent };